app.service('compareView', function() {
	function init() {}
	return {
		init: init
	};
});
